// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"36f8c69fbea78735ad64","303":"0f9006f6e3a8af1bf612","495":"44e0a9f6de18d9747c45"}[chunkId] + ".js";
};